<template>
  <a :href="link" :target="target" :class="buttonClass" class="button" v-if="link">
    <div class="text-cta">{{label}}</div>
  </a>
   <div class="button" :class="buttonClass" v-else>
    <div class="text-cta">{{label}}</div>
  </div>
</template>

<script>
export default {
  props: {
    label: {default: 'Klik hier', type: String},
    type: {default: '', type: String},
    size: {default: '', type: String},
    disabled: {default: false, type: Boolean},
    link: String,
    target: {default: '', type: String}
  },
  data: () => ({
    buttonClass: "",
  }),

  created(){
    console.log(this.type)
    this.buttonClass = `${this.type} ${this.size} ${this.disabled ? 'disabled' : ''}`
    
  }
};
</script>

<style lang="scss" scoped>
  .button{
    display: inline-block;
    padding: 12px 32px;
    line-height: 1;
    cursor: pointer;
    border-radius: 4px;
    text-align: center;
    .text-cta{
      text-transform: uppercase;
    }
    @include tablet-up{
      margin-right: 12px;
    }
    
    &.full{
      width: 100%;
    }
    &.desktop-inline{
      width: 100%;
      @include tablet-up{
        width: auto;
      }
      &.center-aligned{
        position: relative;
        left:50%;
        transform: translate(-50%,0);
      }
    }
    &.mobile-small{
      width: auto;    
    }
    &.mobile-big{
      width: 100%;
      margin-left: 12px;
      @include tablet-up{
        width: auto;
        margin-left: 0;
      }
    }
    &.primary{
      background-color: var(--pink);
      color: var(--white);
      &:hover{
        background-color: var(--pink-dark)
      }
    }
    &.secondary{
      background-color: var(--white);
      color: var(--pink);
      &:hover{
        background-color: var(--white-ash);
      }
    }
    &.tertiary{
      background-color: rgba(0,0,0,0);
      color: var(--pink);
      border: solid 1px var(--pink);
      &:hover{
        background-color: var(--pink-dark);
        color: var(--white);
      }
    }
    &.disabled{
      background-color: var(--white-ash);
      color: var(--gray-dark);
      pointer-events: none;
    }
  }
</style>